// State management for the dcrouter Ops UI, split into per-domain modules.
// This barrel preserves the historical import path for all elements.
export * from './appstate/shared.js';
export * from './appstate/login.js';
export * from './appstate/stats.js';
export * from './appstate/config.js';
export * from './appstate/logs.js';
export * from './appstate/config-events.js';
export * from './appstate/network.js';
export * from './appstate/security.js';
export * from './appstate/ui.js';
export * from './appstate/email-ops.js';
export * from './appstate/certificates.js';
export * from './appstate/acme.js';
export * from './appstate/remoteingress.js';
export * from './appstate/vpn.js';
export * from './appstate/target-profiles.js';
export * from './appstate/profiles-targets.js';
export * from './appstate/domains.js';
export * from './appstate/routes.js';
export * from './appstate/users.js';
export * from './appstate/email-domains.js';
export * from './appstate/smtp-accounts.js';
export * from './appstate/realtime.js';

// Side-effect module: auto-refresh scheduling and TypedSocket log streaming.
import './appstate/runtime.js';
